import { IListData } from '@models';

export class ListDataResponse<T> implements IListData<T> {
  constructor(public list: T[] = [], public total: number = 0) {
  }
}
